import { Reveal } from "@/components/Reveal";
import { Instagram, ArrowUpRight } from "lucide-react";

export function AboutAyush() {
  return (
    <section className="border-t border-border py-24 md:py-32" data-testid="about-ayush">
      <div className="container-px mx-auto max-w-[1600px]">
        <div className="grid items-center gap-14 lg:grid-cols-[0.8fr_1.4fr] lg:gap-20">
          <Reveal>
            <div className="relative mx-auto w-fit">
              <img
                src={`${process.env.PUBLIC_URL}/ayush-sticker.jpg`}
                alt="Ayush"
                className="w-full max-w-[360px] rotate-[-3deg] rounded-[2rem] border-[7px] border-background object-cover shadow-2xl"
                style={{ filter: "drop-shadow(0 10px 30px rgba(0,0,0,0.18))" }}
                data-testid="about-photo"
              />
              <span className="absolute -bottom-4 -right-3 rotate-[-3deg] bg-cyan px-4 py-2 font-mono text-[11px] uppercase tracking-widest text-white shadow-lg">
                City Head · Since 2020
              </span>
            </div>
          </Reveal>

          <div>
            <Reveal>
              <p className="mb-5 font-mono text-xs uppercase tracking-[0.3em] text-cyan">Namaste, I'm Ayush</p>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="font-display text-4xl font-extrabold uppercase leading-[0.95] text-foreground md:text-6xl">
                Your guide to buying<br /><span className="text-muted-foreground">right, the first time.</span>
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-8 max-w-2xl text-base text-muted-foreground md:text-lg">
                I believe buying a home shouldn't feel confusing. As a Real Estate City Head and content creator, I simplify real estate through honest insights, practical tools, and transparent numbers—helping first-time buyers and investors make informed decisions with confidence.
              </p>
            </Reveal>
            <Reveal delay={0.15}>
              <div className="mt-10 flex flex-wrap items-center gap-10">
                <div>
                  <p className="font-display text-4xl font-extrabold text-foreground">6k+</p>
                  <p className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">Instagram family</p>
                </div>
                <div>
                  <p className="font-display text-4xl font-extrabold text-foreground">5+ yrs</p>
                  <p className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">Real estate experience</p>
                </div>
                <div>
                  <p className="font-display text-4xl font-extrabold text-foreground">12</p>
                  <p className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground">Free buyer tools</p>
                </div>
              </div>
            </Reveal>
            <Reveal delay={0.2}>
              <a href="https://www.instagram.com/realestatewithayush/" target="_blank" rel="noreferrer"
                 className="group mt-10 inline-flex items-center gap-2 border border-foreground px-6 py-4 font-mono text-xs uppercase tracking-widest text-foreground transition-colors hover:bg-foreground hover:text-background" data-testid="about-instagram">
                <Instagram className="h-4 w-4" /> Follow @realestatewithayush
                <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
              </a>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
